'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _typeof = require('@babel/runtime-corejs3/helpers/typeof');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);

/**
 * parser format standard class.
 * @type {[type]}
 */
var GraphParserFormat = /*#__PURE__*/function () {
  function GraphParserFormat() {
    _classCallCheck__default["default"](this, GraphParserFormat);
    this.initGQueryFormat().initPTAFormat().initKSubGraphFormat().initGPRFormat().initRestppFormat().initGSTFormat();
  }
  return _createClass__default["default"](GraphParserFormat, [{
    key: "initGQueryFormat",
    value: function initGQueryFormat() {
      this.gquery = {
        isNode: function isNode(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['v_id'] === 'string';
            result = result && typeof obj['v_type'] === 'string';
            // result = result && typeof obj['v_set'] === 'string';
            result = result && (_typeof__default["default"](obj['v']) === 'object' || _typeof__default["default"](obj['attributes']) === 'object');
          }
          return result;
        },
        isLink: function isLink(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['e_type'] === 'string';
            result = result && typeof obj['from_id'] === 'string';
            result = result && typeof obj['from_type'] === 'string';
            result = result && typeof obj['to_id'] === 'string';
            result = result && typeof obj['to_type'] === 'string';
            result = result && typeof obj['directed'] === 'boolean';
            result = result && _typeof__default["default"](obj['attributes']) === 'object';
          }
          return result;
        },
        parseNode: function parseNode(obj) {
          var _context3, _context4, _context5;
          var newNode = {
            id: obj.v_id,
            type: obj.v_type,
            attrs: {},
            styles: {},
            others: {
              'vertex set': obj.v_set
            },
            labels: {}
          };
          if (obj.v) {
            var _context;
            _forEachInstanceProperty__default["default"](_context = _Object$keys__default["default"](obj.v)).call(_context, function (attr) {
              newNode.attrs[attr] = obj.v[attr];
            });
          }
          if (obj.attributes) {
            var _context2;
            _forEachInstanceProperty__default["default"](_context2 = _Object$keys__default["default"](obj.attributes)).call(_context2, function (attr) {
              newNode.attrs[attr] = obj.attributes[attr];
            });
          }
          obj.styles = obj.styles || {};
          obj.others = obj.others || {};
          obj.labels = obj.labels || {};
          _forEachInstanceProperty__default["default"](_context3 = _Object$keys__default["default"](obj.styles)).call(_context3, function (key) {
            newNode.styles[key] = obj.styles[key];
          });
          _forEachInstanceProperty__default["default"](_context4 = _Object$keys__default["default"](obj.others)).call(_context4, function (key) {
            newNode.others[key] = obj.others[key];
          });
          _forEachInstanceProperty__default["default"](_context5 = _Object$keys__default["default"](obj.labels)).call(_context5, function (key) {
            newNode.labels[key] = obj.labels[key];
          });
          return newNode;
        },
        parseLink: function parseLink(obj) {
          var _context6, _context7, _context8, _context9;
          var newLink = {
            source: {
              id: obj.from_id,
              type: obj.from_type
            },
            target: {
              id: obj.to_id,
              type: obj.to_type
            },
            directed: obj.directed,
            type: obj.e_type,
            attrs: {},
            styles: {},
            others: {},
            labels: {}
          };
          _forEachInstanceProperty__default["default"](_context6 = _Object$keys__default["default"](obj.attributes)).call(_context6, function (attr) {
            newLink.attrs[attr] = obj.attributes[attr];
          });
          obj.styles = obj.styles || {};
          obj.others = obj.others || {};
          obj.labels = obj.labels || {};
          _forEachInstanceProperty__default["default"](_context7 = _Object$keys__default["default"](obj.styles)).call(_context7, function (key) {
            newLink.styles[key] = obj.styles[key];
          });
          _forEachInstanceProperty__default["default"](_context8 = _Object$keys__default["default"](obj.others)).call(_context8, function (key) {
            newLink.others[key] = obj.others[key];
          });
          _forEachInstanceProperty__default["default"](_context9 = _Object$keys__default["default"](obj.labels)).call(_context9, function (key) {
            newLink.labels[key] = obj.labels[key];
          });
          return newLink;
        }
      };
      return this;
    }
  }, {
    key: "initPTAFormat",
    value: function initPTAFormat() {
      var _this = this;
      this.pta = {
        isNode: function isNode(obj) {
          return _this.gquery.isNode(obj);
        },
        isLink: function isLink(obj) {
          return _this.gquery.isLink(obj);
        },
        parseNode: function parseNode(obj) {
          var newNode = _this.gquery.parseNode(obj);

          // Remove the @links from attributes
          if ('@links' in newNode.attrs) {
            delete newNode.attrs['@links'];
          }
          return newNode;
        },
        parseLink: function parseLink(obj) {
          return _this.gquery.parseLink(obj);
        }
      };
      return this;
    }
  }, {
    key: "initKSubGraphFormat",
    value: function initKSubGraphFormat() {
      var _this2 = this;
      this.ksubgraph = {
        isNode: function isNode(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['id'] === 'string';
            result = result && typeof obj['v_type'] === 'string';
            result = result && typeof obj['attrs'] === 'string';
          }
          return result;
        },
        isLink: function isLink(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['etype'] === 'string';
            result = result && _typeof__default["default"](obj['src_vertex']) === 'object';
            result = result && _typeof__default["default"](obj['tgt_vertex']) === 'object';
            result = result && typeof obj['attrs'] === 'string';
            if (result) {
              result = result && typeof obj['src_vertex']['vid'] === 'string';
              result = result && typeof obj['src_vertex']['vtype'] === 'string';
              result = result && typeof obj['tgt_vertex']['vid'] === 'string';
              result = result && typeof obj['tgt_vertex']['vtype'] === 'string';
            }
          }
          return result;
        },
        parseNode: function parseNode(obj) {
          var newNode = {
            id: obj.id,
            type: obj.v_type,
            attrs: _this2.gpeTopologyAttributesOutputToJSON(obj.attrs),
            styles: {},
            others: {},
            labels: {}
          };
          return newNode;
        },
        parseLink: function parseLink(obj) {
          var newLink = {
            source: {
              id: obj.src_vertex.vid,
              type: obj.src_vertex.vtype
            },
            target: {
              id: obj.tgt_vertex.vid,
              type: obj.tgt_vertex.vtype
            },
            directed: true,
            type: obj.etype,
            attrs: _this2.gpeTopologyAttributesOutputToJSON(obj.attrs),
            styles: {},
            others: {},
            labels: {}
          };
          return newLink;
        }
      };
      return this;
    }
  }, {
    key: "initGPRFormat",
    value: function initGPRFormat() {
      this.gpr = {
        isNode: function isNode(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['id'] === 'string';
            result = result && typeof obj['vertex_type'] === 'string';
            // result = result && typeof obj['attribute'] === 'object';
          }
          return result;
        },
        isLink: function isLink(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['edge_type_name'] === 'string';
            result = result && _typeof__default["default"](obj['src_vertex']) === 'object';
            result = result && _typeof__default["default"](obj['tgt_vertex']) === 'object';
            // result = result && typeof obj['attribute'] === 'object';

            if (result) {
              result = result && typeof obj['src_vertex']['vertex_id'] === 'string';
              result = result && typeof obj['src_vertex']['vertex_type_name'] === 'string';
              result = result && typeof obj['tgt_vertex']['vertex_id'] === 'string';
              result = result && typeof obj['tgt_vertex']['vertex_type_name'] === 'string';
            }
          }
          return result;
        },
        parseNode: function parseNode(obj) {
          var newNode = {
            id: obj.id,
            type: obj.vertex_type,
            attrs: {},
            styles: {},
            others: {
              'vertex set': obj.v_set
            },
            labels: {}
          };
          for (var attr in obj.attribute) {
            if (Object.prototype.hasOwnProperty.call(obj.attribute, attr)) {
              newNode.attrs[attr] = obj.attribute[attr];
            }
          }
          return newNode;
        },
        parseLink: function parseLink(obj) {
          var newLink = {
            source: {
              id: obj.src_vertex.vertex_id,
              type: obj.src_vertex.vertex_type_name
            },
            target: {
              id: obj.tgt_vertex.vertex_id,
              type: obj.tgt_vertex.vertex_type_name
            },
            directed: obj.directed || false,
            type: obj.edge_type_name,
            attrs: {},
            styles: {},
            others: {},
            labels: {}
          };
          for (var attr in obj.attribute) {
            if (Object.prototype.hasOwnProperty.call(obj.attribute, attr)) {
              newLink.attrs[attr] = obj.attribute[attr];
            }
          }
          return newLink;
        }
      };
      return this;
    }
  }, {
    key: "initRestppFormat",
    value: function initRestppFormat() {
      this.restpp = {
        isNode: function isNode(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['id'] === 'string';
            result = result && typeof obj['vtype'] === 'string';
            result = result && _typeof__default["default"](obj['attributes']) === 'object';
          }
          return result;
        },
        isLink: function isLink(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['etype'] === 'string';
            result = result && typeof obj['from_id'] === 'string';
            result = result && typeof obj['from_vtype'] === 'string';
            result = result && typeof obj['to_id'] === 'string';
            result = result && typeof obj['to_vtype'] === 'string';
            result = result && _typeof__default["default"](obj['attributes']) === 'object';
          }
          return result;
        },
        parseNode: function parseNode(obj) {
          var _context10, _context11, _context12, _context13;
          var newNode = {
            id: obj.id,
            type: obj.vtype,
            attrs: {},
            styles: {},
            others: {},
            labels: {}
          };
          _forEachInstanceProperty__default["default"](_context10 = _Object$keys__default["default"](obj.attributes)).call(_context10, function (attr) {
            newNode.attrs[attr] = obj.attributes[attr];
          });
          obj.styles = obj.styles || {};
          obj.others = obj.others || {};
          obj.labels = obj.labels || {};
          _forEachInstanceProperty__default["default"](_context11 = _Object$keys__default["default"](obj.styles)).call(_context11, function (key) {
            newNode.styles[key] = obj.styles[key];
          });
          _forEachInstanceProperty__default["default"](_context12 = _Object$keys__default["default"](obj.others)).call(_context12, function (key) {
            newNode.others[key] = obj.others[key];
          });
          _forEachInstanceProperty__default["default"](_context13 = _Object$keys__default["default"](obj.labels)).call(_context13, function (key) {
            newNode.labels[key] = obj.labels[key];
          });
          return newNode;
        },
        parseLink: function parseLink(obj) {
          var _context14, _context15, _context16, _context17;
          var newLink = {
            source: {
              id: obj.from_id,
              type: obj.from_vtype
            },
            target: {
              id: obj.to_id,
              type: obj.to_vtype
            },
            directed: true,
            type: obj.etype,
            attrs: {},
            styles: {},
            others: {},
            labels: {}
          };
          _forEachInstanceProperty__default["default"](_context14 = _Object$keys__default["default"](obj.attributes)).call(_context14, function (attr) {
            newLink.attrs[attr] = obj.attributes[attr];
          });
          obj.styles = obj.styles || {};
          obj.others = obj.others || {};
          obj.labels = obj.labels || {};
          _forEachInstanceProperty__default["default"](_context15 = _Object$keys__default["default"](obj.styles)).call(_context15, function (key) {
            newLink.styles[key] = obj.styles[key];
          });
          _forEachInstanceProperty__default["default"](_context16 = _Object$keys__default["default"](obj.others)).call(_context16, function (key) {
            newLink.others[key] = obj.others[key];
          });
          _forEachInstanceProperty__default["default"](_context17 = _Object$keys__default["default"](obj.labels)).call(_context17, function (key) {
            newLink.labels[key] = obj.labels[key];
          });
          return newLink;
        }
      };
      return this;
    }
  }, {
    key: "initGSTFormat",
    value: function initGSTFormat() {
      this.gst = {
        isNode: function isNode(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['vertex_id'] === 'string';
            result = result && typeof obj['vertex_type'] === 'string';
            result = result && _typeof__default["default"](obj['attributes']) === 'object';
            result = result && _typeof__default["default"](obj['other']) === 'object';
          }
          return result;
        },
        isLink: function isLink(obj) {
          var result = true;
          if (_typeof__default["default"](obj) !== 'object' || obj === null) {
            return false;
          } else {
            result = result && typeof obj['edge_type'] === 'string';
            result = result && typeof obj['directed'] === 'boolean';
            result = result && typeof obj['from_id'] === 'string';
            result = result && typeof obj['from_type'] === 'string';
            result = result && typeof obj['to_id'] === 'string';
            result = result && typeof obj['to_type'] === 'string';
            result = result && _typeof__default["default"](obj['attributes']) === 'object';
            result = result && _typeof__default["default"](obj['other']) === 'object';
          }
          return result;
        },
        parseNode: function parseNode(obj) {
          var _context18, _context19, _context20;
          var newNode = {
            id: obj.vertex_id,
            type: obj.vertex_type,
            attrs: {},
            styles: {},
            others: {},
            labels: {}
          };
          _forEachInstanceProperty__default["default"](_context18 = _Object$keys__default["default"](obj.attributes)).call(_context18, function (attr) {
            newNode.attrs[attr] = obj.attributes[attr];
          });
          obj.style = obj.style || {};
          obj.other = obj.other || {};
          _forEachInstanceProperty__default["default"](_context19 = _Object$keys__default["default"](obj.style)).call(_context19, function (key) {
            newNode.styles[key] = obj.style[key];
          });
          _forEachInstanceProperty__default["default"](_context20 = _Object$keys__default["default"](obj.other)).call(_context20, function (key) {
            newNode.others[key] = obj.other[key];
          });
          return newNode;
        },
        parseLink: function parseLink(obj) {
          var _context21, _context22, _context23;
          var newLink = {
            source: {
              id: obj.from_id,
              type: obj.from_type
            },
            target: {
              id: obj.to_id,
              type: obj.to_type
            },
            directed: obj.directed,
            type: obj.edge_type,
            attrs: {},
            styles: {},
            others: {},
            labels: {}
          };
          _forEachInstanceProperty__default["default"](_context21 = _Object$keys__default["default"](obj.attributes)).call(_context21, function (attr) {
            newLink.attrs[attr] = obj.attributes[attr];
          });
          obj.style = obj.style || {};
          obj.other = obj.other || {};
          _forEachInstanceProperty__default["default"](_context22 = _Object$keys__default["default"](obj.style)).call(_context22, function (key) {
            newLink.styles[key] = obj.style[key];
          });
          _forEachInstanceProperty__default["default"](_context23 = _Object$keys__default["default"](obj.other)).call(_context23, function (key) {
            newLink.others[key] = obj.other[key];
          });
          return newLink;
        }
      };
      return this;
    }

    /**
     * convert gpe topology attribute standard output to json object.
     * @example
     * <pre>
     * 'type:2|od_et4:2|od_et5:1|name(0):site12|formula_order(0):2|useAmount(1):6000.000000|' =>
     *  { name: 'site12', 'formula_order': '2', 'useAmount': '6000.000000'}
     * Split by '|', then for each item parse /(.*)\(\d*\):(.*)$/. In this case, 'type', 'od_et4', 'od_et5' are not parsed.
     * </pre>
     * @param {string} attrString [description]
     */
  }, {
    key: "gpeTopologyAttributesOutputToJSON",
    value: function gpeTopologyAttributesOutputToJSON(attrString) {
      if (attrString === '' || attrString === undefined || typeof attrString !== 'string') {
        return {};
      } else {
        var _context24;
        var result = {};
        var reggie = /(.*)\(\d*\):(.*)$/;
        _forEachInstanceProperty__default["default"](_context24 = attrString.split('|')).call(_context24, function (attr) {
          var tempObj = reggie.exec(attr);
          if (tempObj !== null) {
            result[tempObj[1]] = tempObj[2];
          }
        });
        return result;
      }
    }
  }]);
}();

/**
 * Graph parser class.
 */
var GraphParser = /*#__PURE__*/function () {
  function GraphParser() {
    var _this3 = this;
    _classCallCheck__default["default"](this, GraphParser);
    _defineProperty__default["default"](this, "parsers", {});
    _defineProperty__default["default"](this, "parserFormat", new GraphParserFormat());
    this.addParser('static', function (externalData) {
      return externalData;
    });
    this.addParser('gquery', function (externalData) {
      var targetGraph = {
        nodes: [],
        links: []
      };
      try {
        _this3.recursivelyGetExternalElement(externalData, targetGraph, _this3.parserFormat.gquery);
      } catch (err) {
        console.warn(err.toString());
        targetGraph = {
          nodes: [],
          links: []
        };
      }
      return targetGraph;
    });
    this.addParser('pta', function (externalData) {
      var targetGraph = {
        nodes: [],
        links: []
      };
      try {
        _this3.recursivelyGetExternalElement(externalData, targetGraph, _this3.parserFormat.pta);
      } catch (err) {
        console.warn(err.toString());
        targetGraph = {
          nodes: [],
          links: []
        };
      }
      return targetGraph;
    });
    this.addParser('ksubgraph', function (externalData) {
      var targetGraph = {
        nodes: [],
        links: []
      };
      try {
        _this3.recursivelyGetExternalElement(externalData, targetGraph, _this3.parserFormat.ksubgraph);
      } catch (err) {
        console.warn(err.toString());
        targetGraph = {
          nodes: [],
          links: []
        };
      }
      return targetGraph;
    });
    this.addParser('gpr', function (externalData) {
      var targetGraph = {
        nodes: [],
        links: []
      };
      try {
        _this3.recursivelyGetExternalElement(externalData, targetGraph, _this3.parserFormat.gpr);
      } catch (err) {
        console.warn(err.toString());
        targetGraph = {
          nodes: [],
          links: []
        };
      }
      return targetGraph;
    });
    this.addParser('restpp', function (externalData) {
      var targetGraph = {
        nodes: [],
        links: []
      };
      try {
        _this3.recursivelyGetExternalElement(externalData, targetGraph, _this3.parserFormat.restpp);
      } catch (err) {
        console.warn(err.toString());
        targetGraph = {
          nodes: [],
          links: []
        };
      }
      return targetGraph;
    });
    this.addParser('gst', function (externalData) {
      var targetGraph = {
        nodes: [],
        links: []
      };
      try {
        _this3.recursivelyGetExternalElement(externalData, targetGraph, _this3.parserFormat.gst);
      } catch (err) {
        console.warn(err.toString());
        targetGraph = {
          nodes: [],
          links: []
        };
      }
      return targetGraph;
    });
  }

  /**
   * recursively parsing obj to get external graph elements, such as nodes and links. Then add external graph elements in to targetGraph base on the format setting.
   * @param {any}             obj         raw input. It is an random json object, which may contains graph elements.
   * @param {ExternalGraph}   targetGraph The output graph. It is the graph in visualization format.
   * @param {ExternalLink };                       }} format  This is the format object which contians 4 functions:
   * isNode: { (obj: any): boolean }; Check if an obj is a node.
   * isLink: { (obj: any): boolean }; Check if an obj is a link.
   * parseNode: { (obj: any): ExternalNode }; Parser function for a node.
   * parseLink: { (obj: any): ExternalLink }; Parser function for a link.
   */
  return _createClass__default["default"](GraphParser, [{
    key: "recursivelyGetExternalElement",
    value: function recursivelyGetExternalElement(obj, targetGraph, format) {
      if (_typeof__default["default"](obj) !== 'object' || obj === null) {
        return obj;
      }
      var tempObj = obj.constructor ? obj.constructor() : {};
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          tempObj[key] = this.recursivelyGetExternalElement(obj[key], targetGraph, format);
        } else {
          throw new Error('External Data format can not be parased.');
        }
      }
      if (format.isNode(tempObj)) {
        targetGraph.nodes.push(format.parseNode(tempObj));
      }
      if (format.isLink(tempObj)) {
        targetGraph.links.push(format.parseLink(tempObj));
      }
      return tempObj;
    }

    /**
     * Add a parser function by name. Then we can use it by getParser('parserName');
     * @param  {string}           parserName [description]
     * @param  {ExternalGraph }}       callback      [description]
     * @return {this}                        [description]
     */
  }, {
    key: "addParser",
    value: function addParser(parserName, callback) {
      try {
        if (this.parsers[parserName] === undefined) {
          this.parsers[parserName] = callback;
        } else {
          throw new Error("".concat(parserName, " parser is already existed,"));
        }
      } catch (err) {
        console.warn(err.toString());
      }
      return this;
    }

    /**
     * Update a parser function by name. Then we use the updated parser function by getParser('parserName');
     * @param  {string}           parserName [description]
     * @param  {ExternalGraph }}       callback      [description]
     * @return {this}                        [description]
     */
  }, {
    key: "updateParser",
    value: function updateParser(parserName, callback) {
      try {
        if (this.parsers[parserName] !== undefined) {
          this.parsers[parserName] = callback;
        } else {
          throw new Error("".concat(parserName, " parser is already existed,"));
        }
      } catch (err) {
        console.warn(err.toString());
      }
      return this;
    }

    /**
     * Get the target parser function by name.
     * @param  {any}           parserName [description]
     * @return {ExternalGraph}            [description]
     */
  }, {
    key: "getParser",
    value: function getParser(parserName) {
      try {
        if (this.parsers[parserName] === undefined) {
          throw new Error('External data parser is not existed.');
        } else {
          return this.parsers[parserName];
        }
      } catch (err) {
        console.warn(err.toString());
      }
      return this.parsers['gquery'];
    }
  }]);
}();

/**
 * Array parser class. Need to be implemented for LineChart, once we have time.
 */
var ArrayParser = /*#__PURE__*/_createClass__default["default"](function ArrayParser() {
  _classCallCheck__default["default"](this, ArrayParser);
});

exports.ArrayParser = ArrayParser;
exports.GraphParser = GraphParser;
exports.GraphParserFormat = GraphParserFormat;
